(() => {
    let pending = false;
  
    window.addEventListener('abra:cart:changed', function() {
      if (pending) return;
  
      pending = true;
  
      setTimeout(function() {
        const cartDrawer = document.querySelector('m-cart-drawer');
        if (cartDrawer) {
          cartDrawer.onCartDrawerUpdate();
        }
  
        setTimeout(function() {
          pending = false;
        }, 1000);
      }, 50);
    });
  })();

(() => {
  'use strict';

  const apply = (vp) => {
    const jsonEl = vp.querySelector('script#productVariants, script[type="application/json"]');
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch { return; }
    if (!variants?.length) return;

    const selected = [];
    vp.querySelectorAll('input[type="radio"]:checked').forEach((el) => el.name && selected.push(el.value));
    vp.querySelectorAll('select').forEach((s) => s.value && selected.push(s.value));

    const variant =
      variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return opts.length === selected.length && opts.every((o, i) => o === selected[i]);
      }) || variants[0];

    const scope = vp.closest('.m-product-quickview, .m-main-product--wrapper, .m-product-info--wrapper') || document;
    scope.querySelectorAll('.main-product__block-price, .main-product__block-price .m-price')
      .forEach((el) => el.setAttribute('data-variant-id', variant.id));

    const productHandle =
      vp.dataset.productUrl?.split('/products/')[1]?.split('?')[0] ||
      scope.querySelector('[data-product-handle]')?.dataset.productHandle ||
      null;

    if (vp.dataset.lastVariantId !== String(variant.id)) {
      vp.dataset.lastVariantId = String(variant.id);
      window.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: {
            variant,
            variantId: variant.id,
            productId: vp.dataset.productId || null,
            productHandle,
            scope,
            variantPicker: vp,
          },
        })
      );
    }
  };

  const init = (vp) => {
    if (vp.dataset.variantIdSyncBound) return;
    vp.dataset.variantIdSyncBound = '1';
    apply(vp);
    vp.addEventListener('change', () => apply(vp));
    vp.addEventListener('click', (e) => e.target.closest('label[for]') && setTimeout(() => apply(vp), 0));
  };

  const scan = (root = document) => root.querySelectorAll('variant-picker').forEach(init);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => scan())
    : scan();

  document.addEventListener('quick-view:loaded', () => setTimeout(scan, 50));
})();


